export function applyKeyAliases(entry, debugData) {
  const aliases = entry.keyAliases ?? {};
  const source = debugData ?? {};
  const normalized = { ...source };
  const collisions = [];

  for (const [sourceKey, canonicalKey] of Object.entries(aliases)) {
    if (!(sourceKey in source)) continue;

    if (canonicalKey in source) {
      collisions.push({ sourceKey, canonicalKey });
      continue;
    }

    normalized[canonicalKey] = source[sourceKey];
    delete normalized[sourceKey];
  }

  return { normalized, collisions };
}
